module.exports = __webpack_public_path__ + "static/media/ok-react.149aca30.png";